module.exports = __webpack_public_path__ + "media/images/opinion-scale-9e14973b1199acb72d905fc9beb33ced.svg";